import i18n from '@app/localization/i18n';

export function isRequired(value?: string | number | boolean) {
    if (value === null || value === undefined) {
        return i18n.t('this field is required');
    }

    if (typeof value === 'boolean') {
        return value ? false : i18n.t('this field is required');
    }

    return !!value.toString() ? false : i18n.t('this field is required');
}

export function checkValidCharacters(regexRule: string) {
    const regexWhitelistedParts = new RegExp(regexRule, 'g');
    return (value?: string) => {
        if (!value) {
            return false;
        }
        const invalidChars = value.replace(regexWhitelistedParts, '');
        if (invalidChars.length === 0) {
            return false;
        }
        const char = invalidChars[0];
        if (char === ' ' && /\s/.test(value)) {
            return i18n.t('Empty space is forbidden');
        }

        return i18n.t('{char} is forbidden', { char });
    };
}

export function isEmail(value: string) {
    // extra simple email validation
    if (!value) {
        return false;
    }

    return /^.+@.+\..+$/.test(value) ? false : i18n.t('not valid E-mail');
}

export function minLength(min: number) {
    return (value?: string) => {
        if (!value) {
            return false;
        }

        return min <= value.length ? false : i18n.t('minimum length is {value}', { value: min });
    };
}

export function exactSize(size: number) {
    return (value?: string) => {
        if (!value) {
            return false;
        }

        return size === value.length ? false : i18n.t('length should be {value}', { value: size });
    };
}

export function maxLength(max: number) {
    return (value?: string) => {
        if (!value) {
            return false;
        }

        return value.length <= max ? false : i18n.t('maximum length is {value}', { value: max });
    };
}

/**
 * It checks all files but returns error for the first one (app don't have multiple files uploads for now)
 */
export function maxFileSize(maxSize: number, maxSizeHumanReadable: string) {
    return (files?: FileList) => {
        if (!files || !files.length) {
            return false;
        }

        const hasInvalid =  Array.from(files).some((file) => maxSize < file.size);
        return !hasInvalid ? false : i18n.t('maximum file size is {value}', { value: maxSizeHumanReadable });
    };
}

/**
 * Very liberal format checking.  If we want additional restrictions we can check it with FileReader.
 * It checks all files but returns error for the first one (app don't have multiple files uploads for now)
 */
export function allowedFormatsByFilename(allowedFormats: string[]) {
    return (files?: FileList) => {
        if (!files || !files.length) {
            return false;
        }

        const hasInvalid =  Array.from(files).some((file) => !allowedFormats.includes(file.type));
        const extensions = allowedFormats.map((e) => e.split('/')[1]).join(', ');

        return !hasInvalid
            ? false
            : i18n.t('invalid file type (allowed: {extensions})', { extensions });
    };
}

export function min(minValue: number) {
    return (value: number | null | undefined) => {
        if (value === null || value === undefined) {
            return false;
        }

        return minValue <= value ? false : i18n.t('minimum is {value}', { value: minValue });
    };
}

export function max(maxValue: number) {
    return (value: number | null | undefined) => {
        if (value === null || value === undefined) {
            return false;
        }

        return value <= maxValue ? false : i18n.t('maximum is {value}', { value: maxValue });
    };
}

export function isDateInValidFormat(format: RegExp) {
    return (value?: string) => {
        if (!value) {
            return false;
        }

        return format.test(value) ? false : i18n.t('not valid date');
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/shared/validators/forms/index.ts